import React from "react";
import { Checkbox, Table } from "semantic-ui-react";
import { getSortDirection, handleSort } from "../helpers/sort";

const ComplianceAlertTableHeader = ({
  selectAllAlerts,
  handleSelectAll,
  sortColumns,
  setState,
}) => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell textAlign="center">
          <Checkbox
            name="selectAllAlerts"
            checked={selectAllAlerts}
            onChange={handleSelectAll}
          />
        </Table.HeaderCell>
        {sortColumns
          .filter((x) => x.label !== "Name" && x.label !== "Age")
          .map((x) => (
            <Table.HeaderCell
              key={x.name}
              sorted={getSortDirection(sortColumns, x.name, setState)}
              onClick={() => handleSort(sortColumns, x.name)}
              className="text-sm"
            >
              {x.label}
            </Table.HeaderCell>
          ))}
      </Table.Row>
    </Table.Header>
  );
};

export default ComplianceAlertTableHeader;
